import { render, staticRenderFns } from "./ViberInfo.vue?vue&type=template&id=d2b79e1a&"
import script from "./ViberInfo.vue?vue&type=script&lang=js&"
export * from "./ViberInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports